import * as React from 'react';
import { useState, useEffect } from 'react';
import {useNavigate, useLocation, Link} from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Tooltip from '@mui/material/Tooltip';
import LoginIcon from '@mui/icons-material/Login';
import PhoneIcon from '@mui/icons-material/Phone';
import { NavLink } from 'react-router-dom';
import {useAuthState} from '../context';
import MyCapsoLogo from './UI/MyCapsoLogo';
import './UI/Button.css';

const profilePagePath 	= '/acc';
const procedurePagePath = '/pcd';

export default function Navbar() {
	const user = useAuthState().user;
	const orgData = useAuthState().orgData;
	// const hasScheduledCall = useAuthState().hasScheduledCall || false;
	const navigate = useNavigate();
	const location = useLocation();
	const [isProfilePage, setIsProfilePage] = useState(location.pathname === profilePagePath);

	useEffect(() => {
		setIsProfilePage(location.pathname === profilePagePath);
	}, [location.pathname]);

	const handleLogout = async () => {
		navigate('/logout');
	}

	const handlePageChange = (path) => {
		navigate(path);
	}
	
	const pathName = location.pathname.toLowerCase();

	const handlePageToggle = (e) => {
		e.preventDefault();
		navigate(isProfilePage ? procedurePagePath : profilePagePath);
	}

	const gotoProcedurePage = (e) => {
		e.preventDefault();
		navigate(procedurePagePath);
	}

	if (pathName === '/vidconf') {
		return null;
	}

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar position="sticky" color="appbar" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<Toolbar>
					<Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
						<Link to="/">
							<MyCapsoLogo width={120} height="auto" />
						</Link>
						{orgData.organizationAvatarUrl &&
							<Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
								{
									orgData.organizationAvatarUrl ?
									<img 
										src={orgData.organizationAvatarUrl} 
										alt={orgData.organizationName || 'Organization Logo'} 
										style={{ height: 40, marginRight: 12 }}
									/> : orgData.organizationName
								}
							</Box>
						}
						{
							orgData.organizationName &&
							<Chip
								sx={{ display: 'flex', alignItems: 'center', marginX: 1}}
								label={orgData.organizationName}
								variant="outlined"
								onClick={gotoProcedurePage}
							/>
						}
						{orgData.officePhone && (
							<Box sx={{ typography: 'body1', color: 'text.secondary', display: 'flex', alignItems: 'center' }}>
								<PhoneIcon sx={{ fontSize: 'medium', mr: 0.5 }} />
								{orgData.officePhone && orgData.officePhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
							</Box>
						)}
					</Box>
					{ user ?
						(
							<Box>
								{/* <Chip
									variant="outlined"
									icon={<CameraOutdoorIcon />}
									component={NavLink}
									sx={{ ml: 1 }}
									to="/pcd"
									label={hasScheduledCall ? "Video Call Appointment" : "Current Appointment"}
								/> */}
								{/* <Chip
									variant="outlined"
									icon={
										<Badge badgeContent={4} color="secondary">
											<EmailIcon />
										</Badge>
									}
									component={NavLink}
									sx={{ ml: 1 }}
									to="/inbox"
									label={"Inbox"}
								/> */}

								<Tooltip title={isProfilePage ? 'Go To Home Page' : 'Go To Profile Page'}>
									<Chip
										variant="outlined"
										icon={<AccountCircleIcon />}
										label={`${user.firstName} ${user.lastName}`}
										component={NavLink}
										sx={{ ml: 1 }}
										to={isProfilePage ? procedurePagePath : profilePagePath}
										onClick={handlePageToggle}
										className={isProfilePage ? "active" : ""}
									/>
								</Tooltip>
								<Tooltip title="Log Out">
									<Chip
										variant="outlined"
										color="error"
										label="Logout"
										onClick={handleLogout}
										sx={{ ml: 1 }}
									/>
								</Tooltip>
							</Box>
						) : (
							pathName !== '/' && pathName !== '/login' &&
							<IconButton onClick={() => handlePageChange('/')} color="inherit">
								<LoginIcon />
							</IconButton>
						)
					}
				</Toolbar>
			</AppBar>
		</Box>
	);
}